// extracted by mini-css-extract-plugin
export var boxesContainer = "why-use-technology-module--boxes-container--x23LX";
export var innerWrapper = "why-use-technology-module--inner-wrapper--je4Gu";
export var mainTitle = "why-use-technology-module--main-title--LAHTf";
export var section = "why-use-technology-module--section--drE3e";
export var singleBoxDescription = "why-use-technology-module--single-box-description--fR3Ar";